import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/college-luggage-storage-solutions.jpg'),
    alt: 'college luggage storage solutions page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'college luggage storage solutions page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'College <span>Luggage</span><span>Storage Services Fast</span>',
  description:
    'Keep your college belongings safe, organized, and easily accessible with our convenient luggage storage solutions.',
  image: {
    url: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/hero-image.jpg',
    alt: 'College Luggage Storage Services Fast'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Secure Your Luggage Storage Now' }
}

export const ourProcessSectionContent = {
  title: 'How Our College Luggage Storage Solutions Work',
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' },

  image: {
    url: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/how-our-college-luggage-storage-solutions-work.png',
    alt: 'How Our College Luggage Storage Solutions Work'
  },

  articles: [
    {
      id: 1,
      title: 'Easy Online Booking',
      description:
        'Reserve your luggage storage space online with just a few clicks. Choose your preferred pickup and drop-off time to fit your schedule.',
      image: {
        src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/easy-online-booking.png',
        alt: 'Easy Online Booking'
      }
    },
    {
      id: 2,
      title: 'Safe and Secure Facilities',
      description:
        'Store your luggage in our monitored and protected storage units, ensuring your items are safe from theft, damage, and the elements.',
      image: {
        src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/safe-and-secure-facilities.png',
        alt: 'Safe and Secure Facilities'
      }
    },
    {
      id: 3,
      title: 'Convenient Pickup and Delivery',
      description:
        'Enjoy the convenience of having your luggage picked up from your location and delivered to your dorm, apartment, or desired destination.',
      image: {
        src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/convenient-pickup-and-delivery.png',
        alt: 'Convenient Pickup and Delivery'
      }
    }
  ]
}

export const reliableShipSectionContent = {
  id: 1,
  title: 'Fast College Luggage Storage Services',
  description:
    'Fast College Luggage Storage Services offers students secure and convenient options for storing personal belongings during school breaks, travel, or move-in/move-out periods. With flexible plans and reliable facilities, our service ensures that your items are safe, allowing you to focus on your studies and enjoy your time at school.',
  image: {
    src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/fast-college-luggage-storage-services.jpg',
    alt: 'Fast College Luggage Storage Services'
  }
}

export const serviceTipsSectionContent = {
  title: 'Benefits of Using College Luggage Storage Solutions',

  cards: [
    {
      id: 1,
      title: 'Affordable Rates',
      description:
        'We offer competitive pricing, making it easy for students to store their luggage without breaking the bank.',
      image: {
        src: '/images/v2/pages/common/affordable-shipping-options.png',
        alt: 'Affordable Rates'
      }
    },
    {
      id: 2,
      title: 'Secure and Monitored Storage',
      description: 'All luggage is stored in secure, climate-controlled facilities with 24/7 surveillance.',
      image: {
        src: '/images/v2/pages/common/enhanced-security2.png',
        alt: 'Secure and Monitored Storage'
      }
    },
    {
      id: 3,
      title: 'Flexible Storage Duration',
      description:
        'Store your luggage for as long or as short as you need, whether it’s for a weekend, semester break, or extended period.',
      image: {
        src: '/images/v2/pages/common/flexible-storage-duration.png',
        alt: 'Flexible Storage Duration'
      }
    }
  ]
}

export const helperSectionContent = {
  title: 'Who Should Use College Luggage Storage Solutions?',

  articles: [
    {
      content: [
        {
          id: 1,
          title: 'Students Going Home for Breaks',
          description: 'Store your luggage over the holidays or summer break without worrying about taking it all home.'
        },
        {
          id: 2,
          title: 'Study Abroad Students',
          description:
            'Store your belongings while you’re abroad, keeping your space clear and organized for when you return.'
        },
        {
          id: 3,
          title: 'New or Returning Students',
          description:
            'For those moving into or out of dorms, store your luggage until you’re settled into your new space.'
        },
        {
          id: 4,
          title: 'International Students',
          description:
            'Take advantage of our affordable and secure storage options while you travel or during school breaks.'
        }
      ],
      image: {
        src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/who-should-use-college-luggage-storage-solutions.jpg',
        alt: 'Who Should Use College Luggage Storage Solutions?'
      }
    }
  ]
}

export const benefitsSectionContent = {
  title: 'Our College Luggage Storage Services',

  cards: [
    {
      id: 1,
      title: 'Short-Term Luggage Storage',
      description:
        'Need a place to store your luggage for a few days or weeks? Our short-term storage option is perfect for students on the go.',
      image: {
        src: '/images/v2/pages/common/short-term-document-storage.png',
        alt: 'Short-Term Luggage Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 2,
      title: 'Luggage Delivery Service',
      description:
        'Need your luggage delivered to your dorm or destination? We offer reliable, hassle-free delivery options.',
      image: {
        src: '/images/v2/pages/common/luggage-shipping-services.png',
        alt: 'Luggage Delivery Service'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 3,
      title: 'Long-Term Luggage Storage',
      description:
        'Store your luggage for longer periods, whether for a semester, summer break, or during a study abroad program.',
      image: {
        src: '/images/v2/pages/common/long-term-archival-storage.png',
        alt: 'Long-Term Luggage Storage'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    },
    {
      id: 4,
      title: 'Package Handling Services',
      description:
        'In addition to luggage, we offer storage for packages and shipments, ensuring your items are safe until you’re ready for them.',
      image: {
        src: '/images/v2/pages/common/package-handling-services.png',
        alt: 'Package Handling Services'
      },
      link: { href: AUTH_ROUTES.REGISTER.href, text: 'Learn More' }
    }
  ]
}

export const whyChooseSectionContent = {
  title: 'Why Choose Us for College Luggage Storage Solutions?',

  image: {
    url: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/why-choose-us-for-college-luggage-storage-solutions.jpg',
    alt: 'Why Choose Us for College Luggage Storage Solutions?'
  },

  articles: [
    {
      id: 1,
      title: '24/7 Security',
      description: 'Your luggage is stored in secure, fully monitored facilities to protect your belongings.'
    },
    {
      id: 2,
      title: 'Affordable Pricing',
      description:
        'Our budget-friendly storage options help students save money while keeping their belongings safe and secure.'
    },
    {
      id: 3,
      title: 'Convenient Access and Delivery',
      description:
        'Pick up and drop off your luggage at a time and place that works for you, with door-to-door delivery options.'
    },
    {
      id: 4,
      title: 'Simple and Hassle-Free',
      description:
        'Enjoy a stress-free experience with easy online booking, secure storage, and reliable delivery services.'
    },
    {
      id: 5,
      title: 'Flexible Storage Plans',
      description:
        'Whether you need storage for a few days or several months, we offer flexible plans to meet your needs.'
    },
    {
      id: 6,
      title: 'Excellent Customer Support',
      description:
        'Our dedicated customer service team is available to assist you with any questions, ensuring a smooth storage.'
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Fast College Luggage Storage Services Available Now',
  description:
    'College luggage storage services are available now. Fast, affordable, and secure solutions for managing and storing college luggage.',
  image: {
    src: '/images/v2/pages/landing-pages/college-luggage-storage-solutions/fast-college-luggage-storage-services-available-now.png',
    alt: 'Fast College Luggage Storage Services Available Now'
  },
  ctaButton: { href: PUBLIC_MAIN_ROUTES.MOVING_BOX_STORAGE.href, text: 'Reserve Your Storage' }
}

export const ourPartnersSectionContent = {
  title: 'Our Trusted Shipping and Storage Partners',
  description: 'We work with leading shipping carriers to provide reliable luggage storage and delivery services.',

  cards: [
    {
      id: 1,
      title: 'FedEx',
      description: [
        'FedEx ensures your luggage is delivered securely and on time',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. FedEx does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.fedex.com/en-us/home.html' target='_blank'>FedEx.com</a>. FedEx® is a registered trademark. © 1995-2024 FedEx."
      ]
    },
    {
      id: 2,
      title: 'DHL',
      description: [
        'DHL offers efficient and secure solutions for shipping and storing your luggage.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. DHL does not guarantee the accuracy of the information provided. For more information, visit <a href='https://www.dhl.com/global-en/home.html' target='_blank'>DHL.com</a>. DHL® is a registered trademark of DHL International GmbH. All rights reserved."
      ]
    },
    {
      id: 3,
      title: 'UPS',
      description: [
        'UPS provides reliable shipping and storage services to keep your luggage secure.',
        "<strong>Disclaimer:</strong> This page was last updated in September 2024 for reference only. UPS does not guarantee the accuracy or completeness of the information provided. For more information, visit <a href='https://www.ups.com' target='_blank'>UPS.com</a>. UPS® is a registered trademark of UPS Inc. All rights reserved."
      ]
    }
  ]
}
